<template>
  <div class="container-fluid autenticacao">
    <div class="card autenticacao-card autenticacao-card--medium">
      <div class="card-header">
        <div class="card-header-content">
          <div class="card-title-group">
            <div class="card-icon-badge">
              <i class="pi pi-search"></i>
            </div>
            <div>
              <h5 class="panel-title">Consulta de RPS Convertido em NFS-e</h5>
              <p class="panel-subtitle">Verifique se o seu Recibo Provisório foi convertido em Nota Fiscal</p>
            </div>
          </div>
        </div>
      </div>
      <div id="topo" class="card-body">
        <div class="form-title-links">
          <span class="form-title"
            >Informe os dados do prestador, tomador e documento para consultar o status de conversão do RPS.</span
          >
        </div>

        <!-- Tipo de Validação (Pills) -->
        <div class="form-group-modern">
          <label class="form-label-section">Consultar por:</label>
          <div class="radio-pill-group">
            <label class="radio-pill-item" :class="{ active: tipoValidacao === 'R' }">
              <RadioButton
                inputId="radio1"
                name="tipoValidacao"
                value="R"
                v-model="tipoValidacao"
                tabindex="1"
              />
              <span>Número RPS</span>
            </label>
            <label class="radio-pill-item" :class="{ active: tipoValidacao === 'L' }">
              <RadioButton
                inputId="radio2"
                name="tipoValidacao"
                value="L"
                v-model="tipoValidacao"
                tabindex="2"
              />
              <span>Número Lote RPS</span>
            </label>
          </div>
        </div>

        <!-- Grid 2 Colunas -->
        <div class="form-grid-2col">
          <div class="form-group-field">
            <label for="cpfCnpjPrestador" class="form-label-modern">CPF/CNPJ do prestador: *</label>
            <InputText
              id="cpfCnpjPrestador"
              type="text"
              @blur="validarDocumento()"
              @keyup.enter="consultar()"
              placeholder="Digite o CPF ou CNPJ"
              autocomplete="off"
              tabindex="3"
              class="input-modern"
              v-model="documentoPrestador"
            />
          </div>

          <div class="form-group-field">
            <label for="inscMunicPrestador" class="form-label-modern">Inscrição Municipal do prestador:</label>
            <InputText
              id="inscMunicPrestador"
              type="text"
              @keyup.enter="consultar()"
              placeholder="Digite a Inscrição Municipal"
              autocomplete="off"
              tabindex="4"
              class="input-modern"
              maxlength="40"
              v-model="inscricaoPrestador"
            />
          </div>

          <div class="form-group-field">
            <label for="cpfCnpjTomador" class="form-label-modern">CPF/CNPJ do tomador: *</label>
            <InputText
              id="cpfCnpjTomador"
              type="text"
              @blur="validarDocumentoTomador()"
              @keyup.enter="consultar()"
              placeholder="Digite o CPF ou CNPJ"
              autocomplete="off"
              tabindex="5"
              class="input-modern"
              v-model="documentoTomador"
            />
          </div>

          <div class="form-group-field">
            <label for="numero" class="form-label-modern">Número: *</label>
            <InputText
              id="numero"
              type="text"
              @keyup.enter="consultar()"
              placeholder="Digite o número"
              autocomplete="off"
              tabindex="6"
              maxlength="20"
              class="input-modern"
              v-model="numero"
            />
          </div>

          <div class="form-group-field">
            <label for="serie" class="form-label-modern">Série RPS:</label>
            <InputText
              id="serie"
              type="text"
              @keyup.enter="consultar()"
              placeholder="Digite a série do RPS"
              autocomplete="off"
              tabindex="7"
              maxlength="20"
              class="input-modern"
              v-model="serie"
            />
          </div>

          <div class="form-group-field">
            <label for="tipoRps" class="form-label-modern">Tipo RPS:</label>
            <InputText
              id="tipoRps"
              type="text"
              @keyup.enter="consultar()"
              placeholder="Digite o tipo do RPS"
              autocomplete="off"
              tabindex="8"
              maxlength="20"
              class="input-modern"
              v-model="tipoRps"
            />
          </div>
        </div>

        <!-- Botões de Ação -->
        <div class="form-actions-modern" v-if="!sistemaBloqueado">
          <Button
            label="Voltar ao Login"
            type="button"
            class="btn-modern-secondary"
            id="btnVoltar"
            @click="login()"
            icon="pi pi-arrow-left"
            :disabled="loading"
          />
          <Button
            label="Consultar RPS"
            type="submit"
            class="btn-modern-primary"
            id="btnAutenticar"
            @click="consultar()"
            icon="pi pi-search"
            :disabled="loading"
          />
        </div>
      </div>
    </div>
        <Dialog
            class="test-box"
            header="Informação"
            :visible.sync="showDialog"
            :modal="true"
            :closable="false"
          >
            <div class="container">
              <div id="topo" class="row">
                <div class="col-md-12 mb-2">
                  <label for="tipoTomador">Rps convertida em Nota Fiscal, deseja realizar a impressão?</label>
                </div>
              </div>
            </div>

            <hr />

            <div class="container">
              <div class="row">
                <div>
                  <Button
                    @click="visualizarNfse()"
                    href="#topo"
                    type="button"
                    label="Sim"
                    class="p-button-primary mr-2 p-button-success"
                    icon="pi pi-check"
                    :disabled="loading"
                  />
                </div>

                <div>
                  <Button
                    @click="showDialog = false"
                    type="button"
                    label="Não"
                    class="p-button-primary mr-2 p-button-danger"
                    icon="pi pi-times"
                  />
                </div>
              </div>
            </div>
          </Dialog>
  </div>
</template>

<script>
import AutenticacaoService from "../services/nfse/autenticacao.service";
import DnsClienteService from "../services/nfse/dns.cliente.service";
import Util from "../Utils/util";

export default {
  data() {
    return {
      documentoPrestador: '',
      inscricaoPrestador: '',
      documentoTomador: '',
      numero: '',
      serie: '',
      tipoRps: '',
      tipoValidacao: null,
      loading: false,
      idCliente: null,
      anoAtual: null,
      showDialog: false,
      notaFiscalId: null,
      sistemaBloqueado: false
    };
  },

  mounted() {
    this.$nextTick(() => {
      const el = document.getElementById("cpfCnpjPrestador");
      if (el) el.focus();
    });
    var d = new Date();
    this.anoAtual = d.getFullYear();

    if (!this.idCliente) {
      this.processando(true);
    }
    let host = window.location.hostname;
    DnsClienteService.get(host)
      .then((dns) => {
        if (dns && dns.data && dns.data.idCliente) {
          this.idCliente = dns.data.idCliente;
          if (dns.data.idBolBloquearSistema && dns.data.idBolBloquearSistema === 'S') {
            this.sistemaBloqueado = true;
          }
        }
      })
      .finally(() => {
        this.processando(false);
      });
  },

  created() {
    try {
      const raw = localStorage.getItem('nfse_login_cache') || sessionStorage.getItem('nfse_login_cache');
      if (raw) {
        const cached = JSON.parse(raw);
        if (cached) {
          this.idCliente = cached.idCliente || null;
          this.sistemaBloqueado = !!cached.sistemaBloqueado;
        }
      }
    } catch (e) {
      console.warn(e);
    }

    this.limparDados();
  },

  methods: {
    limparDados() {
      this.documentoPrestador = '';
      this.inscricaoPrestador = '';
      this.documentoTomador = '';
      this.numero = '';
      this.serie = '';
      this.tipoRps = '';
      this.tipoValidacao = "R";
      this.loading = false;
      this.notaFiscalId = null;
    },

    login() {
      this.$router.push("/login");
    },

    consultar() {
      this.processando(true);
      if (
        this.documentoPrestador &&
        this.documentoTomador &&
        this.numero &&
        this.tipoValidacao &&
        this.idCliente
      ) {
        AutenticacaoService.consultarRps(
          this.tipoValidacao,
          this.documentoPrestador.trim(),
          (this.inscricaoPrestador != null  ? this.inscricaoPrestador.trim() : null),
          this.documentoTomador.trim(),
          this.numero.trim(),
          this.serie.trim(),
          this.tipoRps.trim(),
          this.idCliente
        ).then(
            response => {
              this.notaFiscalId = response.data;
              console.log(this.notaFiscalId);
              this.showDialog = true;
              
            },
            error => {
              this.$root.$emit("alert:error", error.response.data);
            }
          ).then(() => {
            this.processando(false);
          });
      }else{
        this.$root.$emit("alert:warn", "Preencha os campos obrigatórios!");
        this.processando(false);
      }
    },

    visualizarNfse() {
      this.processando(true);
      if (
        this.notaFiscalId
      ) {
        AutenticacaoService.visualisarNfse(
          this.notaFiscalId
        )
          .then(
            () => {this.showDialog = false;},
            error => {
              this.$root.$emit("alert:warn", "Erro ao exibir a visualização!");
              console.log(error);
            }
          )
          .then(() => {
            this.processando(false);
          });
      }
    },

    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit("loading:show");
      } else {
        this.loading = false;
        this.$root.$emit("loading:hide");
      }
    },

    validarDocumento() {
      var validar = false;
      validar = Util.validarCPFCNPJ(this.documentoPrestador);

      if (!validar && this.documentoPrestador) {
        console.log(validar);
        this.documentoPrestador = '';
        this.$root.$emit("alert:error", "CPF/CNPJ Prestador inválido!");
      }
    },
    validarDocumentoTomador() {
      var validar = false;
      validar = Util.validarCPFCNPJ(this.documentoTomador);

      if (!validar && this.documentoTomador) {
        console.log(validar);
        this.documentoTomador = '';
        this.$root.$emit("alert:error", "CPF/CNPJ Tomador inválido!");
      }
    }
  }
};
</script>

<style src="../assets/css/links-autenticacao-recibo-credenciamento-contribuintes.css"></style>